import { useSelector } from 'react-redux';

import { selectAnonymousUsername } from 'selectors/shareVideo';
import { getAnonUserName } from 'utilities/auth';

const useAnonymousUsername = () => {
  const username = useSelector(selectAnonymousUsername);

  if (username === null) {
    return getAnonUserName();
  }

  return username;
};

export default useAnonymousUsername;
